export enum TypeBrief {
    CAMPANA = 'CAMPANA',
    INICIATIVA = 'INICIATIVA',
    TACTICA = 'TACTICA'
}